function getBootstrapPayload() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.__SUARTE_SSR__?.content ?? null;
}

export function getSsrContentBootstrap(contentId) {
  const payload = getBootstrapPayload();
  if (!payload) {
    return null;
  }

  if (payload.contentId !== contentId) {
    return null;
  }

  return payload;
}
